<template>
  <div class="user-page__content">
    <ul v-if="addresses && addresses.length" class="user-page__address-list">
      <li v-for="(address, i) in addresses" :key="i">
        <span class="user-page__address">
          {{ getFullAddress(address) }}
        </span>
        <div class="user-page__address-actions">
          <button @click="editAddress(address)" class="user-page__address-action btn">
            <IconComponent name="edit" />
          </button>
          <button @click="deleteAddress(address.id)" class="user-page__address-action btn">
            <FileIconComponent v-if="loading_id === address.id" name="loading" />
            <IconComponent v-else name="trush-square" />
          </button>
        </div>
      </li>
    </ul>
    <span v-else>Адреса отсутствуют</span>
    <div class="user-page__footer">
      <button @click="showAddressModal" type="button" class="btn btn--md btn--main">Добавить адрес</button>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import AddressModal from "components/modals/components/AddressModal.vue";
import FileIconComponent from "components/FileIconComponent.vue";
import ADDRESS_DELETE from "gql/mutations/AddressDelete.graphql";

export default {
  name: "AddressPage",
  data() {
    return {
      loading_id: null,
    };
  },
  computed: {
    addresses() {
      return this.$store.state.auth.addresses;
    },
  },
  methods: {
    deleteAddress(id) {
      if (!this.loading_id) {
        this.loading_id = id;
        this.$apollo.provider.defaultClient
          .mutate({
            mutation: ADDRESS_DELETE,
            variables: {
              id: id,
            },
            context: {
              headers: {
                Authorization: "Bearer " + this.$store.state.apollo_token,
              },
            },
          })
          .then(() => {
            this.$emit("reload", this.$apolloProvider, this.$store, this.$route);
          })
          .finally(() => {
            this.loading_id = null;
          });
      }
    },
    showAddressModal() {
      this.$store.state._modals.push({
        component: AddressModal,
        options: {},
        stretch: true,
      });
    },
    editAddress(address) {
      this.$store.state._modals.push({
        component: AddressModal,
        options: {
          editAddress: address,
        },
        stretch: true,
      });
    },
    getFullAddress(address) {
      return [address.address, address.apartment, address.entrance, address.intercom, address.floor]
        .filter((a) => a)
        .join(", ");
    },
    stopLoading() {
      this.loading = null;
    },
  },
  components: { FileIconComponent, IconComponent },
};
</script>

<style lang="stylus">
.user-page__address {
  &-list {
    width 100%
    display grid

    li {
      padding 13px 20px
      border-bottom 1px solid var(--main-color-75)
      display flex
      align-items center
      justify-content space-between
      gap 15px
    }
  }

  &-actions {
    flex-shrink 0
    display flex
    gap 15px
  }

  &-action {
    display flex
    background none
    border none
    cursor pointer

    .icon,
    .file-icon {
      width: 20px
      height 20px

      svg path {
        stroke var(--main-color)
        transition var(--transition)
      }

      svg circle {
        stroke var(--main-color)
      }
    }

    &:hover svg {
      path, circle {
        stroke var(--main-color-75)
      }
    }
  }

  &__footer {
    display: flex;
    justify-content flex-end
    align-items center
  }
}
</style>
